/*ěščřžýáíéúů*/

// Our Brands Component JavaScript
document.addEventListener("DOMContentLoaded", function () {
    // SwiperJS pro our-brands slider
    function initOurBrandsSwiper() {
        const brandsSwiper = new Swiper(".our-brands__slider-swiper", {
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: true,
            freeMode: true,
            navigation: {
                nextEl: ".buttons-our-brands__next",
                prevEl: ".buttons-our-brands__prev",
            },
        });
    }

    // Inicializuj our-brands swiper
    if (document.querySelector(".our-brands__slider-swiper")) {
        initOurBrandsSwiper();
    }
});
